import { useQuery, requestDeals } from '@workspace/api';

export interface SubscribeLinks {
    april_moto: {
        velo: string;
        trottinette: string;
        livraison: string;
        autres: string;
    };
    assurland: { autres: string };
    le_lynx: { autres: string };
    meilleur_taux: { autres: string };
    les_furets: { autres: string };
    lfa: { autres: string };
    rva: { autres: string };
    lsa: { autres: string };
    assurpeople: { autres: string };
}

export function useSubscribeLinks(options: { enabled?: boolean } = {}) {
    return useQuery<{ data: SubscribeLinks }>({
        queryKey: ['deals', 'subscribe-links'],
        queryFn: async () => {
            const response = await requestDeals.get<{ data: SubscribeLinks }>('/api/subscribe-links');
            return response.data;
        },
        staleTime: 30 * 60 * 1000,
        enabled: options.enabled ?? true,
    });
}
